module.exports = __webpack_public_path__ + "img/thomas-tucker-MNtag_eXMKw-unsplash.2a96d14b.jpg";